import at from 'sportnet-utilities/lib/at';

export default (
  params: { [key: string]: any },
  parameterKeys: string[] = Object.keys(params),
  delimiter: string = '|',
) => {
  return at(params, parameterKeys).join(delimiter);
};
